export default "__VITE_ASSET__Cd0oj58m__"